export enum LoginResponseCode {
  invalid_user = 'invalid_user',
  login_verification_max_attempt_reached = 'login_verification_max_attempt_reached',
  login_verification_required = 'login_verification_required',
  ok = 'ok',
}

export enum OtpResendResponseCode {
  ATTEMPT_NOT_FOUND = 'ATTEMPT_NOT_FOUND',
  RESEND_COOLDOWN = 'RESEND_COOLDOWN',
  RESEND_ERROR = 'RESEND_ERROR',
  RESEND_MAX_LIMIT = 'RESEND_MAX_LIMIT',
  RESEND_OK = 'ok',
}

export enum OtpResponseCode {
  ATTEMPT_ERROR = 'ATTEMPT_ERROR',
  ATTEMPT_EXCEEDED_LIMIT = 'ATTEMPT_EXCEEDED_LIMIT',
  ATTEMPT_EXPIRED = 'ATTEMPT_EXPIRED',
  ATTEMPT_FAILED = 'ATTEMPT_FAILED',
  ATTEMPT_NOT_FOUND = 'ATTEMPT_NOT_FOUND',
  ATTEMPT_OK = 'ok',
}
